module.exports = __webpack_public_path__ + "img/ai_icon.en.48aa1413.png";